import ApiService from './ApiService'

export const apiCore = async (url, method, data, options = {}) => (
  ApiService.fetch({
      url, method, data, ...options
  })
)